import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../assests/css/customer/CustomerSideBar.css';
import AppContext from '../../context/AppContext';

const CustomerSideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthToken, setIsLoggedIn } = useContext(AppContext);
  
  const [activeItem, setActiveItem] = useState('my-profile');

  const menuItems = [
    { 
      id: 'my-profile', 
      label: 'My Profile', 
      path: '/customer/profile', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      )
    },
    { 
      id: 'my-orders', 
      label: 'My Orders', 
      path: '/customer/order', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
      )
    },
        { 
      id: 'wishlist', 
      label: 'Wishlist', 
      path: '/wishlist', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      )
    },
         { 
      id: 'cart-management', 
      label: 'Cart', 
      path: '/cart', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
      )
    },
    { 
      id: 'user-notification', 
      label: 'Notification', 
      path: '/customer/notification', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
      )
    },
    // { 
    //   id: 'reviews', 
    //   label: 'Reviews', 
    //   path: '/customer/reviews', 
    //   icon: (
    //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    //       <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    //     </svg>
    //   )
    // },
    { 
      id: 'help-support', 
      label: 'Help & Support', 
      path: '/customer/helpsupport', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      )
    },
    { 
      id: 'settings', 
      label: 'Settings', 
      path: '/customer/setting', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M12 1v6m0 6v6m5.66-13a7 7 0 0 1 0 10M6.34 5a7 7 0 0 0 0 10"></path>
        </svg>
      )
    },
    { 
      id: 'logout', 
      label: 'Logout', 
      path: 'logout', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
          <polyline points="16 17 21 12 16 7"></polyline>
          <line x1="21" y1="12" x2="9" y2="12"></line>
        </svg>
      ),
      isLogout: true 
    }
  ];

  // Update active item based on current route
  useEffect(() => {
    const currentItem = menuItems.find(item => item.path === location.pathname);
    if (currentItem) {
      setActiveItem(currentItem.id);
    }
  }, [location.pathname]);
    const handlelogout = (item) => {
    if (item.isLogout) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("CustomerEmail");
      setAuthToken(null);
      setIsLoggedIn(false);
      navigate('/');
    } else {
      setActiveItem(item.id);
      navigate(item.path);
    }
  };

  const isActive = (item) => {
    return location.pathname === item.path;
  };

  return (
    <div className="user-sidebar-wrapper">
      <div className="user-sidebar-container">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`user-sidebar-item ${isActive(item) ? 'user-sidebar-active' : ''} ${item.isLogout ? 'user-sidebar-logout' : ''}`}
            onClick={() => handlelogout(item)}
          >
            <span className="user-sidebar-icon">{item.icon}</span>
            <span className="user-sidebar-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerSideBar;